import { get } from 'lodash'
import { OfferCardType } from '../shoplist-app/shopping/types/ShoppingPageType'
import {
  HONEY_OFFER_ID_QUERY_KEY,
  HONEY_STORE_ID_QUERY_KEY,
  SHOPPING_STORE_ITEM_PRESSED
} from './client-constants'
import { StoreProfileFPTI } from '../shoplist-app/store-profile/StoreProfilePage'
import { sendFptiClick } from './fpti-pa'
const getHoneyOfferUrl = (offer: OfferCardType, landingUrl?: string) => {
  const actions = get(offer, 'actions', [])
  const offerURL = actions.length > 0 ? actions[0].navigationTarget : null
  return offerURL ? offerURL : landingUrl
}

const getOutClickUrl = (
  { honeyOfferId, storeIds }: OfferCardType,
  previousUrlSearchParams: URLSearchParams
) => {
  if (!storeIds || storeIds.length < 2 || !honeyOfferId) {
    return window.location.href
  }

  previousUrlSearchParams.append(HONEY_OFFER_ID_QUERY_KEY, honeyOfferId)
  previousUrlSearchParams.append(HONEY_STORE_ID_QUERY_KEY, storeIds[1])

  const newQueryParams = previousUrlSearchParams.toString()

  const outClickUrl = `${window.location.origin}${window.location.pathname}?${newQueryParams}`
  return outClickUrl
}

const handleOfferOutclick = (
  offer: OfferCardType,
  triggeringComponent: 'BUTTON' | 'CARD',
  fptiData: StoreProfileFPTI | null,
  landingUrl?: string
) => {
  if (typeof window === 'undefined') {
    return
  }

  const offerTargetUrl = getHoneyOfferUrl(offer, landingUrl)
  // if no offer target url is present then we don't link anywhere
  if (!offerTargetUrl) {
    return
  }

  const urlSearchParams = new URLSearchParams(window.location.search)

  // if HONEY_OFFER_ID_QUERY_KEY 'honeyOfferId' is present in the urlSearchParams that means we have to
  // perform open offer target url on a new tab
  if (urlSearchParams.get(HONEY_OFFER_ID_QUERY_KEY) !== null) {
    // If component is Button and type is CODE the outclick should not apply and let the copy logic to
    // continue
    if (triggeringComponent === 'BUTTON' && offer.honeyOfferType === 'CODE') {
      sendFptiClick({
        event_name: SHOPPING_STORE_ITEM_PRESSED,
        banner_type: offer.honeyOfferType.toLowerCase(),
        rank: offer.rank,
        link_name: 'copy code',
        offer_id: offer.honeyOfferId,
        ...fptiData
      })
      return
    }
    sendFptiClick({
      event_name: SHOPPING_STORE_ITEM_PRESSED,
      banner_type: offer.honeyOfferType.toLowerCase(),
      rank: offer.rank,
      link_name: offer.honeyOfferType === 'CODE' ? 'code' : 'deal',
      offer_id: offer.honeyOfferId,
      ...fptiData
    })
    window.open(offerTargetUrl, '_blank')
    return
  }
  // the first time the offer is clicked we should open in new tab Store Details Page
  // with the needed query params to open the Offer Details Modal
  // and redirect the current tab to the offer target url
  sendFptiClick({
    event_name: SHOPPING_STORE_ITEM_PRESSED,
    banner_type: offer.honeyOfferType.toLocaleLowerCase(),
    rank: offer.rank,
    link_name: 'store and modal',
    offer_id: offer.honeyOfferId,
    ...fptiData
  })
  const outClickUrl = getOutClickUrl(offer, urlSearchParams)
  window.open(outClickUrl, '_blank')
  window.location.href = offerTargetUrl
}

export const handleCardOfferOutclick = (
  offer: OfferCardType,
  fptiData: StoreProfileFPTI | null,
  landingUrl?: string
) => {
  return handleOfferOutclick(offer, 'CARD', fptiData, landingUrl)
}

export const handleButtonOfferOutclick = (
  offer: OfferCardType,
  fptiData: StoreProfileFPTI | null,
  landingUrl?: string
) => {
  return handleOfferOutclick(offer, 'BUTTON', fptiData, landingUrl)
}
